<template>
  <div
    class="full-area padded vertically-centered bg-image"
    :class="{ 'full-area-desktop': fullWidth || data.fields.darkBackground, 'scrollable': data.fields.isScrollable, 'animated-background': data.fields.darkBackground }"
    :style="{backgroundImage: `url(${bgImage})`}"
  >
    <div class="yet-another-wrapper">
      <div class="logo"
        v-if="data.fields.logo"
      >
        <img :src="data.fields.logo.fields.file.url">
      </div>
      <div class="swipeable-area"
        v-if="routeName === 'page'"
        v-touch:swipe.left="swipeLeftHandler"
        v-touch:swipe.right="swipeRightHandler"
      ></div>
      <div class="desktop-control delay-entry"
        v-if="arrows && !data.fields.isScrollable && routeName === 'page'"
      >
        <div
          @click="previous()"
        >
          <Icons
            class="icon"
            icon="chevron-left"
            size="96"
            :color="data.fields.darkBackground ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.4)'"
          ></Icons>
        </div>
        <div
          @click="next()"
        >
          <Icons
            class="icon"
            icon="chevron-right"
            size="96"
            :color="data.fields.darkBackground ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.4)'"
          ></Icons>
        </div>
      </div>
      <h2 v-if="data.fields.questionTitle">{{data.fields.questionTitle}}</h2>

      <vue-markdown class="html-content">{{data.fields.text}}</vue-markdown>

      <div
        class="hide delay-entry smartphone-next"
        @click="next()"
        v-if="data.fields.darkBackground"
      >
        <Icons
          class="icon"
          icon="chevron-right"
          size="96"
          :color="data.fields.darkBackground ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.4)'"
        ></Icons>
      </div>

      <p
        class="padded"
        v-if="!data.fields.darkBackground"
      >
        <el-button
          round
          type="danger"
          @click="selectThis('next')"
          class="align-right"
        >{{data.fields.callToAction || 'Siguiente' }}</el-button>
      </p>
      <p class="small" v-html="data.fields.remarks"></p>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'

export default {
  name: 'Screen',

  transition: 'page',

  props: [ 'data', 'fullWidth' ],

  components: {
    VueMarkdown,
    Icons: () => import('Components/base/Icons')
  },

  data () {
    return {
      arrows: false,
      form: {
        question: this.data.fields.questionTitle,
        id: this.data.sys.id,
        selected: null,
        timeToCompletion: null,
        timestamps: {
          start: new Date(),
          finish: null,
          valid: null
        }
      }
    }
  },

  computed: {
    bgImage () {
      if (this.data.fields.backgroundImage) {
        return this.data.fields.backgroundImage.fields.file.url
      }
      return ''
    },
    routeName () {
      return this.$route.name
    }
  },

  methods: {
    swipeRightHandler () {
      this.previous()
    },
    swipeLeftHandler () {
      this.next()
    },
    selectThis (item) {
      this.form.selected = ['next']
    },
    next () {
      this.arrows = false
      this.form.timestamps.finish = new Date()
      this.$emit('next', this.form)
    },
    previous () {
      this.arrows = false
      this.form.timestamps.finish = new Date()
      this.$emit('previous', this.form)
    },
    validInput (value) {
      // Add simple validation: if it exists, it is valid.
      if (value) {
        this.form.timestamps.valid = new Date()
        this.form.timeToCompletion = this.form.timestamps.valid.getTime() - this.form.timestamps.start.getTime()
        return true
      } else {
        return false
      }
    }
  },

  mounted () {
    setTimeout(() => {
      this.arrows = true
    }, 300)
  },

  watch: {
    // Add a simple watch to trigger next automatically after some ms
    'form.selected': function (newVal, oldVal) {
      if (this.validInput(newVal)) {
        setTimeout(() => {
          this.next()
        }, 200)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.bg-image {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.full-area-desktop {
  max-width: 100vw;
}

.full-area.scrollable {
  padding: 10px 20px;
  display: block;
}

.full-area.padded {
  padding: 2% 5%;

  @include breakpoint($desktop) {
    padding: 5% 10%;
  }
  .yet-another-wrapper {
    max-width: 800px;
    margin: auto;
    position: relative;
    z-index: 1;

    .swipeable-area {
      position: fixed;
      height: 70vh;
      width: 80vw;
      margin: 0 auto;
      top: 0;
      left: 10vw;
      background: transparent;
      z-index: 0;
    }
    .button {
      position: relative;
      z-index: 20;
    }
    .smartphone-next {
      position: fixed;
      bottom: 0.5em;
      right: 0em;
      z-index: 20;

      @include breakpoint($desktop) {
        display: none;
      }
      .icon {
        position: relative;
        z-index: 30;
      }
    }
    .desktop-control {
      display: none;

      @include breakpoint($desktop) {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        height: 100vh;
        width: 100vw;
        top: 0;
        left: 0;
        bottom: 0;
        margin: auto;
      }
      .icon {
        transition: transform 0.2s ease-in-out;
        &:hover {
          transform: scale(1.1);
          cursor: pointer;
        }
      }
    }
    .logo {
      width: 100%;
      margin-bottom: 1.5em;
      margin-top: 1em;
      border-bottom: 1px solid $gray-light;
      padding-bottom: 1.5em;
      text-align: left;
      img {
        max-width: 150px;
      }
    }
  }
}

.animated-background {
  background: linear-gradient(221deg, $color-wrapper-emphasis, $color-wrapper-emphasis-lighter) !important;
  background-size: 400% 400%;

  -webkit-animation: CirclingBackground 0.4s ease infinite;
  -moz-animation: CirclingBackground 0.4s ease infinite;
  animation: CirclingBackground 0.4s ease infinite;
  color: white;

  .html-content {
    blockquote {
      p {
        color: $color-wrapper-emphasis-lighter;
      }
    }
  }
}

</style>
